import * as React from 'react'

function SvgSj(props) {
	return (
		<svg viewBox="0 0 1100 800" width="1em" height="1em" {...props}>
			<path fill="#ef2b2d" d="M0 0h1100v800H0z" />
			<path fill="#fff" d="M300 0h200v800H300z" />
			<path fill="#fff" d="M0 300h1100v200H0z" />
			<path fill="#002868" d="M350 0h100v800H350z" />
			<path fill="#002868" d="M0 350h1100v100H0z" />
		</svg>
	)
}

export default SvgSj
